function calcBars(sum, years, percent) {
  let bars = {
    series: [
      { name: "Вложения", data: [] },
      {
        name: "Заработаный интресс",
        data: [],
      },
    ],
    chartOptions: {
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return "$" + val;
        },
      },
      chart: {
        type: "bar",
        height: 350,
        stacked: true,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            legend: {
              //position: "bottom",
              offsetX: -10,
              offsetY: 0,
            },
          },
        },
      ],
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 10,
        },
      },
      xaxis: {
        type: "category",
        categories: [],
      },
      legend: {},
      fill: {
        opacity: 1,
      },
    },
  };

  for (let i = 1; i <= years; i++) {
    // console.log("this many years: " + i);
    let pf = Math.pow(percent / 100 + 1, i) - 1;
    let ff = pf / (percent / 100);
    let fv = sum * ff * 12;

    // just intress
    let intres = (fv - sum * i * 12).toFixed(0);
    bars.series[1].data.push(intres);

    // add investments
    let investment = sum * i * 12;
    bars.series[0].data.push(investment);

    // add series
    bars.chartOptions.xaxis.categories.push(i);
  }

  return bars;
}

module.exports = calcBars;
